import config from './data.json'
import {headerLinks} from './meta-data'
import {
    getPermissions,
    PERMISSIONS_ROUTES_ONLY,
    PERMISSIONS_SECTIONS_ONLY
} from './acl'
import AppConfigApi from './AppConfigApi'

const metadata = config.metadata
export {
    PERMISSIONS_ROUTES_ONLY,
    PERMISSIONS_SECTIONS_ONLY,
    metadata,
    getPermissions,
    headerLinks,
    AppConfigApi
}
